import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {TableConfig} from '@app/shared/util/table-config.utils';
import {UserRole} from "@models/role.model";
import {Tool} from "@app/tool/model/tool.model";
import {TableComponent} from "@components/custom-table/table.component";

@Component({
    selector: 'app-tool-request-facilities-tools-table',
    templateUrl: 'tool-request-facilities-tools-table.html',
    styleUrls: ['tool-request-facilities-tools-table.scss']
})
export class ToolRequestFacilitiesToolsTableComponent {
    @ViewChild(TableComponent, {static: false}) table: TableComponent;
    @Input() tools = new Array<Tool>();
    @Input() userRoles = new Array<UserRole>();
    @Input() userStates = new Array<any>();
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() treeMode = false;
    @Input() rowExpand = false;
    @Input() filter = true;
    @Input() tree = true;
    @Input() showFilters = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();

    groupableColumns = [
        {id: 0, name: 'Part number', value: 'PartNumber'},
        {id: 1, name: 'Equipment', value: 'Equipment'},
        {id: 2, name: 'Line', value: 'Line'}];

    filterStatusList = [
        {name: 'All', value: undefined},
        {name: 'Available', value: true},
        {name: 'Not Available', valued: false},
    ];


    constructor() {

    }

    onPageChange(tableConfig: TableConfig) {
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this.filterChange.emit(tableConfig);
    }

    toggleExpand(allExpanded: boolean) {
        this.table.onExpandAll(allExpanded);
    }
}
